"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Ref, Component, PropSync, Mixins } from "vue-property-decorator";
import Question from "@/components/Question.vue";
import { AccountSessionMixins } from "@/service/account-session";
import { Columns, Column } from "../../../virtual-element/elements/table/core";
let VirtualDesktopTableBody = class extends Mixins(
  AccountSessionMixins
) {
  constructor() {
    super(...arguments);
    this.columns = new Columns();
  }
  get $controller() {
    return this._controller;
  }
  get columnList() {
    return Array.from(this.columns.columns());
  }
  sortChange(sort) {
    var _a;
    let _sort = (_a = this.columns.use(sort.prop)) == null ? void 0 : _a.sort(sort);
    this.$controller.query.sort = _sort;
    this.$controller.search();
  }
  handleSelectionChange(selected) {
    this.$controller.selected.splice(0, this.$controller.selected.length);
    for (const _item of selected) {
      this.$controller.selected.push(_item);
    }
  }
  clearSelection() {
    this.$controller.selected.splice(0, this.$controller.selected.length);
    this._tableBody.clearSelection();
  }
  created() {
    return __async(this, null, function* () {
      this.columns.add(
        new Column("name", {
          label: this.$t("vdcontainer.name").toString(),
          component: require("./columns/ColumnName.vue").default,
          sort: "name"
        })
      );
      this.columns.add(
        new Column("proxy", {
          label: "IP",
          component: require("./columns/ColumnProxy.vue").default
        })
      );
      this.columns.add(
        new Column("shop", {
          label: this.$t("vdcontainer.shop").toString(),
          component: require("./columns/ColumnShops.vue").default,
          width: "150px"
        })
      );
      this.columns.add(
        new Column("goods_end_time", {
          label: this.$t("vdcontainer.end_date").toString(),
          component: require("./columns/ColumnGoodsEndDate.vue").default,
          sort: "expiredTime"
        })
      );
      this.columns.add(
        new Column("administrator", {
          label: this.$t("vdcontainer.administrator").toString(),
          component: require("./columns/ColumnOwner.vue").default,
          sort: "admins",
          width: "90px"
        }),
        "false"
      );
      this.columns.add(
        new Column("automatic_renewal", {
          label: this.$t("vdcontainer.automatic_renewal").toString(),
          component: require("./columns/ColumnRenew.vue").default,
          width: this.$i18n.locale === "zh-CN" ? "100px" : "180px",
          question: this.$t(
            "vdcontainer.after_automatic_renewal_is_turned_on_the_system_will"
          ).toString()
        })
      );
      this.columns.add(
        new Column("online", {
          label: this.$t("vdcontainer.online").toString(),
          component: require("./columns/ColumnOnline.vue").default
        })
      );
      if (this.$session.marks.is("UPLOAD_SHOP_FILE")) {
        this.columns.add(
          new Column("enclosure", {
            label: this.$t("vdcontainer.enclosure").toString(),
            component: require("./columns/ColumnUploadFiles.vue").default,
            width: this.$i18n.locale === "zh-CN" ? "50px" : "120px"
          }),
          "false"
        );
      }
      this.columns.add(
        new Column("operation", {
          label: this.$t("vdcontainer.operation").toString(),
          header: {
            component: require("../../../virtual-element/elements/table/headers/HeaderOperate.vue").default
          },
          component: require("./columns/ColumnOperate.vue").default,
          width: "166px"
        })
      );
      const _viewStorage = localStorage.getItem("vd.column.view");
      if (_viewStorage !== null) {
        const _view = JSON.parse(_viewStorage);
        const enclosure_index = _view.findIndex((item) => {
          return item.name === "enclosure";
        });
        if (this.$session.marks.is("UPLOAD_SHOP_FILE") && enclosure_index === -1) {
          return;
        }
        this.columns.views(_view);
      }
    });
  }
  // 此处预留可变列变换方法
  formatColumns() {
    return __async(this, null, function* () {
      try {
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  openRemote(column) {
    this.$emit("openRemote", column.modelResource);
  }
  openEnclosureDialog(column) {
    this.$emit("openEnclosureDialog", column.modelResource);
  }
  openLauncher(column) {
    this.$emit("openLauncher", column.modelResource);
  }
  createshop(column) {
    this.$emit("createshop", column);
  }
  moveShop(column) {
    this.$emit("moveShop", column);
  }
  editShop(column) {
    this.$emit("editShop", column);
  }
  changename(column) {
    this.$emit("changename", column);
  }
  bindIP(column) {
    this.$emit("bindIP", column);
  }
  proxySetting(column) {
    this.$emit("proxySetting", column);
  }
  setFavorite(column) {
    this.$emit("setFavorite", column);
  }
  setUnFavorite(column) {
    this.$emit("setUnFavorite", column);
  }
  chooseAdmin(column) {
    this.$emit("chooseAdmin", column);
  }
  stickToTop(column) {
    this.$emit("stickToTop", column);
  }
  unstickToTop(column) {
    this.$emit("unstickToTop", column);
  }
  editGroup(column) {
    this.$emit("editGroup", column);
  }
  deleteVD(column) {
    this.$emit("deleteVD", column);
  }
  realDeleteVD(column) {
    this.$emit("realDeleteVD", column);
  }
  moveVD(column) {
    this.$emit("moveVD", column);
  }
  clearCache(column) {
    this.$emit("clearCache", column);
  }
  openForceDialog(item) {
    this.$emit("openForceDialog", item);
  }
  toUrge(item) {
    this.$emit("urge", item);
  }
  proxyShare(item) {
    this.$emit("proxyShare", item);
  }
};
__decorateClass([
  Ref("table-body")
], VirtualDesktopTableBody.prototype, "_tableBody", 2);
__decorateClass([
  PropSync("controller")
], VirtualDesktopTableBody.prototype, "_controller", 2);
VirtualDesktopTableBody = __decorateClass([
  Component({
    components: {
      Question
    }
  })
], VirtualDesktopTableBody);
export {
  VirtualDesktopTableBody as default
};
